import RecoverAccountPage from './RecoverAccount';

export default RecoverAccountPage;
